import { useApolloClient, useMutation } from '@apollo/client'
import { useCallback } from 'react'
import {
  AddReplyLikeDocument,
  RemoveReplyLikeDocument,
  ReplyLikeFragmentDoc,
} from '~/__generated__/graphql'

export const useReplyLike = (replyId: string) => {
  const client = useApolloClient()
  const data = client.cache.readFragment({
    id: `Reply:${replyId}`,
    fragment: ReplyLikeFragmentDoc,
  })

  const [addReplyLike] = useMutation(AddReplyLikeDocument, { variables: { replyId } })
  const [removeReplyLike] = useMutation(RemoveReplyLikeDocument, { variables: { replyId } })

  const onClickLike = useCallback(() => {
    if (data?.currentUserHasLike == true) {
      removeReplyLike({
        update: (cache) => {
          if (!!data) {
            cache.writeFragment({
              id: `Reply:${replyId}`,
              fragment: ReplyLikeFragmentDoc,
              data: {
                currentUserHasLike: false,
                likeNum: (data.likeNum ?? 1) - 1,
              },
            })
          }
        },
      })
    } else {
      addReplyLike({
        update: (cache) => {
          if (!!data) {
            cache.writeFragment({
              id: `Reply:${replyId}`,
              fragment: ReplyLikeFragmentDoc,
              data: {
                currentUserHasLike: true,
                likeNum: (data.likeNum ?? 0) + 1,
              },
            })
          }
        },
      })
    }
  }, [data, replyId, addReplyLike, removeReplyLike])

  return {
    data,
    onClickLike,
  }
}
